import { render } from "./module.vue?vue&type=template&id=66ac8f4d"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/module-catboxes/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66ac8f4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66ac8f4d', __exports__)) {
    api.reload('66ac8f4d', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=66ac8f4d", () => {
    api.rerender('66ac8f4d', render)
  })

}


export default __exports__